// extracted by mini-css-extract-plugin
module.exports = {"head":"ThanksAppMain_head__27onD","des":"ThanksAppMain_des__NQxTi","btnCont":"ThanksAppMain_btnCont__323Xq","btn1":"ThanksAppMain_btn1__1bvsy","btn2":"ThanksAppMain_btn2__1Pd6Y"};